import { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import { listAvailableDemands } from '../../Services/demandLifecycle';
import { distanceKm, getArtisanServiceLocation, getDemandPublicLocation } from '../../Utils/geo';

const POLL_INTERVAL_MS = 60 * 1000;

const GeoNotificationWatcher = ({ artisanId, profile }) => {
  const seen = useRef(new Set());

  useEffect(() => {
    const enabled = profile?.geo_notifications?.enabled !== false;
    const center = getArtisanServiceLocation(profile);
    const radius = Number(profile?.service_area?.radius_km) || 30;
    if (!artisanId || profile?.user_type !== 'Artisan' || profile?.availability_status === 'unavailable' || !enabled || !center || !profile?.speciality) return undefined;

    let active = true;
    let firstLoad = true;
    const check = async () => {
      try {
        const demands = await listAvailableDemands();
        if (!active) return;
        const nextIds = new Set(demands.map((demand) => demand.demand_id));
        if (!firstLoad) {
          demands.filter((demand) => !seen.current.has(demand.demand_id)).forEach((demand) => {
            const location = getDemandPublicLocation(demand);
            const distance = distanceKm(center, location);
            if (!Number.isFinite(distance) || distance > radius) return;
            const key = `lpb-geo-notified-${demand.demand_id}`;
            if (localStorage.getItem(key)) return;
            localStorage.setItem(key, String(Date.now()));
            toast.info(`Nouveau projet à ${distance < 10 ? distance.toFixed(1) : Math.round(distance)} km de vous`, {
              onClick: () => { window.location.href = '/newjobs'; },
              autoClose: 8000,
            });
          });
        }
        seen.current = nextIds;
        firstLoad = false;
      } catch (error) {
        if (active && error?.code !== 'functions/failed-precondition') console.warn('[GeoNotificationWatcher]', error);
      }
    };

    check();
    const interval = window.setInterval(check, POLL_INTERVAL_MS);
    return () => { active = false; window.clearInterval(interval); };
  }, [artisanId, profile]);

  return null;
};

const mapStateToProps = ({ firebase: firebaseState }) => ({
  artisanId: firebaseState?.auth?.uid,
  profile: firebaseState?.profile || {},
});

export default connect(mapStateToProps)(GeoNotificationWatcher);
